<script>
  import { countries, euCountries, gdpr } from '../constants';
  import { sanitizeDomain, validateDomain, hubspotLeadSubmit } from '../util';
  import { spfLookup } from '../api.js';
  import { onMount } from 'svelte';


  let error = false;
  let loading = false;
  let inputSelector = '';
  let inputDomainName = '';
  let inputEmail = '';
  let inputCountry = '';
  let validForm = null;
  let formGUID = '6c23172a-1484-4813-9f7c-11733835827a';
  let hubspotutk = '';
  let url = '';

  onMount(async () => {
    url = window.location.href;
    //console.log('page url = ' + url);

    hubspotutk = getHubspotUtkCookie();
    //console.log('hubspotutk = ' + hubspotutk);
  });

  $: validDomain = validateDomain(inputDomainName);
  $: isEUCountry = euCountries.includes(inputCountry);

  function lookupDomain() {
    inputSelector = sanitizeDomain(inputSelector);
    inputDomainName = sanitizeDomain(inputDomainName);

    validForm = inputDomainName != '' && inputEmail != '' && inputCountry != '';
    error = false;

    if (!validForm) return;

    if (validateDomain(inputDomainName)) {
      loading = true;
      let formValues = {
        'spf_domain': inputDomainName,
        'email': inputEmail,
        'spf_record_status': 'Record Found',
        'country': inputCountry,
      };

      let context = {
        "hutk": hubspotutk, // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
        "pageUri": url,
        "pageName": "SPF Lookup"
      };

      if (isEUCountry) {
        let gdprValues = [];
        Object.values(gdpr).forEach(item => {
          if (item.value == true) {
            gdprValues.push(item.text);
          }
        });
        formValues.gdpr_contact_methods = gdprValues.join('; ');
      }

      spfLookup(inputDomainName, inputSelector).catch(err => {
        error = err.message;
        formValues.spf_record_status = 'Record Not Found';
      });

      console.log(formValues);
      // Hubspot background submit.
      // @see https://developers.marketo.com/blog/make-a-marketo-form-submission-in-the-background/
      hubspotLeadSubmit(formValues, context, formGUID);
    }
  }

  const getHubspotUtkCookie = () => {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'hubspotutk') {
        return value;
      }
    }
    return null;
  };
</script>

<section class="tool-banner tool-banner-spf mb-5">
  <div class="banner"></div>
  <div class="row-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 m-auto">
          <div class="result-box">
            <form
              on:submit|preventDefault={lookupDomain}
              class="spf-search"
            >
              <div class="search-row">
                <div class="row">
                  <div class="mb-3 col-sm-6">
                    <input
                      bind:value={inputDomainName}
                      class="form-control form-control-lg"
                      name="domain_name"
                      placeholder="Enter your domain here..."
                      maxlength="255"
                      type="text"
                      title="Enter a fully qualified domain name"
                    >
                  </div>
                  <div class="mb-3 col-sm-6">
                    <input
                      bind:value={inputEmail}
                      class="form-control form-control-lg"
                      name="email"
                      placeholder="Email address"
                      maxlength="255"
                      type="email"
                      required
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="mb-3 col-sm-6">
                    <select
                      bind:value={inputCountry}
                      class="form-control form-control-lg"
                      aria-label="Country"
                      required
                    >
                      <option value="" selected>Country</option>
                      {#each countries as country }
                        <option value={country}>{country}</option>
                      {/each}
                    </select>
                  </div>
                  {#if isEUCountry}
                    <div class="mb-3">
                      <p>We will use your data to provide you with information regarding your request. From time to time, we would like to contact you about our products and services, along with other content that may be of interest to you. If you consent to us contacting you for this purpose, please tick the options below.</p>
                      {#each Object.entries(gdpr) as [id, item]}
                        <div class="form-check">
                          <input bind:checked={item.value} class="form-check-input" type="checkbox" id="{id}">
                          <label class="form-check-label" for="{id}">
                            {item.text}
                          </label>
                        </div>
                      {/each}
                    </div>
                  {/if}
                  <div class="text-center col-sm-6">
                    <button
                      disabled={!validDomain || loading}
                      class:loading
                      class="btn btn-lg btn-1 mx-auto w-100"
                      type="submit"
                    >
                      Find Record
                    </button>
                  </div>
                  {#if inputDomainName != '' && !validDomain}
                    <div class="text-danger">Invalid domain name.</div>
                  {/if}
                  {#if validForm != null && !validForm}
                    <div class="text-danger">All fields are required.</div>
                  {/if}
                  {#if error}
                    <div class="text-danger">Invalid domain name.</div>
                  {/if}
                </div>
                
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- <section class="section row bg-7">
	<div class="col-sm-12">
		<div class="container">
			<h2 class="section-title">
				Understanding SPF Protection
			</h2>
			<p class="text-center">Learn more about SPF and how it can protect from the SPooF</p>
			<p class="text-center mt-5"><a href="/solutions/email-security/spf" class="btn btn-1">Learn more</a></p>
		</div>
	</div>
</section> -->

<style>

</style>
